import { StyleSheet, TouchableOpacity, ViewStyle } from "react-native"

import MaterialIcons from "@expo/vector-icons/MaterialIcons"

import { useAppTheme } from "src/hooks/useAppTheme"

const SIZE = 36

interface CloseButtonProps {
  onPress: () => void
  style?: ViewStyle | ViewStyle[] | (ViewStyle | false | undefined)[]
  accessibilityLabel?: string
}

/**
 * Shared circular close button used across all screens.
 * Callers are responsible for positioning (absolute, fixed, etc.).
 */
export function CloseButton({ onPress, style, accessibilityLabel = "Close" }: CloseButtonProps) {
  const { theme } = useAppTheme()
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.button, { backgroundColor: theme.colors.buttonBackground }, style]}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
    >
      <MaterialIcons name="close" size={20} color={theme.colors.buttonText} />
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  button: {
    width: SIZE,
    height: SIZE,
    borderRadius: SIZE / 2,
    justifyContent: "center",
    alignItems: "center",
  },
})
